import React from "react";
import Chart from "react-apexcharts";
import { helpers } from "services";
import useTranslation from "hooks/useTranslation";
import ResponsiveApexContainer from "components/ResponsiveApexContainer";

const SalesByCategory = ({ items = [] }) => {
  const { tr } = useTranslation();

  const sortedArr = [...items].sort((a, b) => Number(b.price) - Number(a.price));
  const series = sortedArr.reduce(
    (prev, curr) => [...prev, Number(curr.price)],
    []
  );
  const categories = sortedArr.reduce((prev, curr) => [...prev, curr.name], []);

  return (
    <div className="dashboard-panel h-100-percent">
      <div className="dashboard-panel__head">
        <div>{tr("Доля по категории продуктов")}</div>
      </div>
      <div className="dashboard-panel__body">
        {sortedArr.length === 0 ? null : (
          <ResponsiveApexContainer height={380}>
            {chartWidth => (
              <Chart
                options={{
                  yaxis: {
                    labels: {
                      formatter: function(value) {
                        return helpers.convertToReadable(value);
                      },
                    },
                  },
                  chart: {
                    toolbar: {
                      show: false,
                    },
                  },
                  legend: {
                    position: "bottom",
                  },
                  labels: categories,
                  dataLabels: {
                    enabled: true,
                    formatter: function(val) {
                      return val.toFixed(2) + "%";
                    },
                  },
                }}
                series={series}
                type="donut"
                width={chartWidth}
                height={"380"}
              />
            )}
          </ResponsiveApexContainer>
        )}
      </div>
    </div>
  );
};

export default SalesByCategory;
